import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Routes, RouterModule} from '@angular/router';
import {MaterialModule} from 'src/app/core/material';
import {UpdateEnterpriseComponent} from './update-enterprise/update-enterprise.component';
import {EnterpriseComponent} from './enterprise.component';
import {SharedModule} from 'src/app/shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';
import {ConfirmDeactivateGuard} from 'src/app/core/guards/confirm-deactivate.guard';
import {OtpRegisterComponent} from './otp-register/otp-register.component';
import {OtpVerifyComponent} from './otp-register/otp-verify/otp-verify.component';
import {AuthGuard} from 'src/app/core/auth/auth.guard';
import {CanActivateChildGuard} from 'src/app/core/guards/can-activate-child.guard';
import {ViewEnterpriseComponent} from './view-enterprise/view-enterprise.component';
import { DEFAULT_FULL_PERMISSION_LIST } from 'src/app/core/constants/permission';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ConfirmIndentifyComponent } from './confirm-indentify/confirm-indentify.component';
import { ConfirmFailComponent } from './confirm-fail/confirm-fail.component';
import { ConfirmSuccessComponent } from './confirm-success/confirm-success.component';
import { KycSignComponent } from './kyc-sign-enterprise/kyc-sign.component';
import { KycSignModuleEnterprise } from './kyc-sign-enterprise/kyc-sign.module';
import { KycConfirmAccountModuleReviewEnterprise } from './kyc-confirm-account-review-enterprise/kyc-confirm-account.module';
import { KycConfirmAccountReviewComponent } from './kyc-confirm-account-review-enterprise/kyc-confirm-account.component';
import { ConfirmCancelComponent } from './confirm-cancel/confirm-cancel.component';


const routes: Routes = [
  {
    path: 'update-enterprise',
    component: UpdateEnterpriseComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    data: {
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: [1],
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'view-enterprise',
    canDeactivate: [ConfirmDeactivateGuard],
    component: ViewEnterpriseComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    data: {
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: [1],
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: [1],
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'kyc-sign-enterprise',
    component: KycSignComponent,
    canActivate: [
      AuthGuard
    ],
    loadChildren: () => import('./kyc-sign-enterprise/kyc-sign.module').then(m => m.KycSignModuleEnterprise)
  },
  {
    path: 'kyc-sign-enterprise-anonymous/:hashKey/:tenantId',
    component: KycSignComponent,
    canActivate: [
      AuthGuard
    ],
    loadChildren: () => import('./kyc-sign-enterprise/kyc-sign.module').then(m => m.KycSignModuleEnterprise)
  },
  {
    path: 'kyc-confirm-account-review-enterprise',
    component: KycConfirmAccountReviewComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./kyc-confirm-account-review-enterprise/kyc-confirm-account.module').then(m => m.KycConfirmAccountModuleReviewEnterprise)
  },
  {
    path: 'kyc-confirm-account-review-anonymous-enterprise/:hashKey/:tenantId',
    component: KycConfirmAccountReviewComponent,
    loadChildren: () => import('./kyc-confirm-account-review-enterprise/kyc-confirm-account.module').then(m => m.KycConfirmAccountModuleReviewEnterprise)
  },
  // {
  //   path: 'otp-register',
  //   canDeactivate: [ConfirmDeactivateGuard],
  //   component: OtpRegisterComponent
  // }
];

@NgModule({
  declarations: [
    UpdateEnterpriseComponent,
    EnterpriseComponent,
    OtpRegisterComponent,
    OtpVerifyComponent,
    ViewEnterpriseComponent,
    ConfirmIndentifyComponent,
    ConfirmFailComponent,
    ConfirmSuccessComponent,
    ConfirmCancelComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    TranslateModule,
    NgxExtendedPdfViewerModule,
    KycSignModuleEnterprise,
    KycConfirmAccountModuleReviewEnterprise
  ],
  exports: [],
  entryComponents: [
    OtpVerifyComponent,
    ConfirmIndentifyComponent,
    ConfirmFailComponent,
    ConfirmSuccessComponent,
    ConfirmCancelComponent
  ]
})
export class EnterpriseModule {
}
